<template>
  <div class="list no-border platform-delimiter">


    <router-link to="/mailing/messages"
    class="item item-link"
    v-no-select>
      <div class="item-link-with-icon">
        <i class="file-text-o"></i>
        <div class="">Messages</div>
      </div>
    </router-link>

    <router-link to="/mailing/templates"
    class="item item-link"
    v-no-select>
      <div class="item-link-with-icon">
        <i class="file-o"></i>
        <div class="">Templates</div>
      </div>
    </router-link>
    
    <router-link to="/mailing/envois"
    class="item item-link"
    v-no-select>
      <div class="item-link-with-icon">
        <i class="paper-plane"></i>
        <div class="">Envois</div>
      </div>
    </router-link>

    <router-link to="/mailing/options"
    class="item item-link"
    v-no-select>
      <div class="item-link-with-icon">
        <i class="gears"></i>
        <div class="">Options</div>
      </div>
    </router-link>

  </div>

</template>

<script>
import Vuex from 'vuex'
import List_meta from './List_meta.js'
import typeahead from '../components/utils/typeahead.js'

export default {
  data: function () {
    return {
      // search_fields: List_meta.search_fields,
      // search_fields_index: List_meta.search_fields_index,
      // search_modes: List_meta.search_modes,
      // search_modes_index: List_meta.search_modes_index
    }
  },

  computed: {
    ...Vuex.mapGetters({
      selected: 'listSelection'
    }),

    type_str: function () {
      return this.$route.params.type
    },

    is_new: function () {
      return !!this.$route.fullPath.match(/\/new/)
    },

    is_edit: function () {
      return !!this.$route.fullPath.match(/\/edit/)
    },

    is_list: function () {
      return !!this.$route.fullPath.match(/^\/gestion\/[^/]+\/?$/)
    }
  },

  methods: {
    ...Vuex.mapActions({
      getList: 'get_list',
      del_contacts: 'del_contacts',
      del_contact: 'del_contact',
      merge_contacts: 'merge_contacts'
    }),

    onDel: function () {
      var vm = this
      // console.log(this.$route.params.contact_id)
      if (typeof this.$route.params.contact_id !== 'undefined') {
        this.del_contact(this.$route.params.contact_id)
        .then(function () {
          vm.$router.push('/gestion/' + vm.$route.params.type)
        })
      }
      else if (this.selected.length > 0) {
        this.del_contacts()
        .then(function () {

        })
      }
    },

    onMerge: function () {
      this.merge_contacts()
      // this.getList()
    },

    onClassify: function () {
      this.$store.commit('ListSetActionModalState', true)
    },

    onExport: function () {
      this.$store.commit('ListSetExportModalState', true)
    }
  },

  mounted () {
    // if (this.$route.path.indexOf('/contact') < 0) {
    //   this.setSearchType(2)
    // }
    // else {
    //   this.setSearchType(1)
    // }
  }
}
</script>

<style>
.search_item i {
  font-size: 1rem;
  color: #34495e;
}
.search_item .dropdown_display {
  /*padding: 0.25rem;*/
}

.item.item-link {
  overflow: visible;
}
</style>
